import React from 'react';
import { Button, Group, Modal, ModalProps } from '@mantine/core';
import styles from './CustomModal.module.css';

interface ConfirmModalProps extends Partial<ModalProps> {
  opened: boolean;
  onClose: () => void;
  onConfirm?: () => void;
  title?: string;
  children: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  showButtons?: boolean;
}

const CustomModal: React.FC<ConfirmModalProps> = ({
  opened,
  onClose,
  onConfirm,
  title,
  children,
  confirmLabel = 'Zapisz',
  cancelLabel = 'Anuluj',
  showButtons = true,
  size = 'md',
  radius = 'sm',
  ...modalProps
}) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={title}
      size={size}
      radius={radius}
      classNames={{
        header: styles.modalHeader,
        body: styles.modalBody,
        inner: styles.modalContent,
      }}
      {...modalProps}
    >
      {children}
      {showButtons && (
        <Group mt="md">
          {onConfirm && <Button onClick={onConfirm}>{confirmLabel}</Button>}
          <Button color="red" onClick={onClose}>
            {cancelLabel}
          </Button>
        </Group>
      )}
    </Modal>
  );
};

export default CustomModal;
